module.exports = __webpack_public_path__ + "static/media/plane.82cb7734.svg";